import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import "../styles/Home.css";
import AddMatchPopup from "./AddMatchPopup";
import AddBallPopup from "./AddBallPopup";
import {
  conditionalRowStyles,
  custombatsmanbowlertableStyles,
} from "../assets/tablestyle";
import {
  get_drs_tyes,
  get_drs_match,
  get_cricket_asscotions,
  get_video_urls,
} from "../api/serverWrapper";

import { hexToRGBA, shapesForDrawLine } from "../componants/CommonFuncations";
import impactIcon from "../assets/images/impactBall.png";
import pitchingIcon from "../assets/images/pitchingBall.png";
import horizontalIcon from "../assets/images/line2.png";
import verticalIcon from "../assets/images/line1.png";
import pitchMapIcon from "../assets/images/rectangle.png";
import SixCamImg from "../assets/images/6cams.png";
import FourCamImg from "../assets/images/4cams.png";
import PopupVideo from "./PopupVideo";
import { AddIcon, VideoIcon, EditIconNew } from "../assets/SvgIcons";
import EditBallPopup from "./EditBallPopup";
import LoginCard from "./LoginCard";
import { getData } from "../utils/localstorage_constants";
import { IS_LOGGED, USER_SYSTEM_ROLE } from "../utils/localstorage_variables";
import UserSystemRole from "../componants/UserSystemRole";

export default function Home() {
  const [isLogin, setIsLogin] = useState(true);
  const [systemRole, setSystemRole] = useState(null);
  const [showAddMatch, setShowAddMatch] = useState(false);
  const [showAddBall, setShowAddBall] = useState(false);
  const [drsTypes, setDrsTypes] = useState([]);
  const [matches, setMatches] = useState([]);
  const [cricketAsscotions, setCricketAsscotions] = useState([]);

  let [ballurls, setBallUrls] = useState();
  let [cameraview, setCameraView] = useState();
  const [singlecam, setSingleCam] = useState(true);
  const [fourcam, setFourCam] = useState(false);
  const [sixcam, setSixCam] = useState(false);
  const [isVisible, setPopup] = useState(false);
  const [isValid, setIsValid] = useState(false);
  let [isfourcamactive, setIsFourCamActive] = useState(false);
  const [issixcamactive, setIsSixCamActive] = useState(false);

  useEffect(() => {
    loadintialData();
    checkLogin();
  }, []);

  const checkLogin = async () => {
    // let login = await getData(IS_LOGGED);
    // setIsLogin(login);

    let role = await getData(USER_SYSTEM_ROLE);
    setSystemRole(role);
  };

  const loadintialData = async () => {
    // load initial data here
    try {
      let drs_types_resp = await get_drs_tyes();
      // console.log("drs_types_resp",drs_types_resp.data);

      setDrsTypes(drs_types_resp.data);

      let matches_resp = await get_drs_match();
      console.log("matches_resp", matches_resp);
      setMatches(matches_resp.data);

      let cricket_asscotions_resp = await get_cricket_asscotions();
      // console.log("cricket_asscotions_resp", cricket_asscotions_resp.data);
      setCricketAsscotions(cricket_asscotions_resp.data);
    } catch (error) {
      console.log(error);
    }
  };

  const [activeCamTab, setActiveCamTab] = useState("cam1");
  const handleCamTab = (tab, activecam) => {
    cameraview = activecam;
    setCameraView(cameraview);
    setActiveCamTab(tab);
    handleSingleCamChange();
  };

  const handlevideopopup = async (row) => {
    const parts = row.split("_");

    const [
      prefix,
      matchId,
      innNum,
      overNum,
      ballNum,
      extraIndex,
      deploymentId,
    ] = parts;

    // Convert numeric parts to integers if needed
    // Example: matchId might be 1205 (string), convert to number
    const matchIdNum = parseInt(matchId, 10);
    const innNumNum = parseInt(innNum, 10);
    const overNumNum = parseInt(overNum, 10);
    const ballNumNum = parseInt(ballNum, 10);
    const extraIndexNum = parseInt(extraIndex, 10);
    const deploymentString = deploymentId;

    // Now you can use these values to call your API, for example:
    let resp = await get_video_urls(
      matchIdNum,
      innNumNum,
      overNumNum,
      ballNumNum,
      extraIndexNum,
      deploymentString
    );

    let ballurls = resp.data;
    console.log("ballurls", resp);
    setBallUrls(ballurls);
    let cameraview = ballurls?.c1;
    setCameraView(cameraview);

    console.log("ballurls", ballurls);
    handleVisibility();
  };

  const [showPopup, setShowPopup] = useState(false);
  const [selectedBall, setSelectedBall] = useState(null);
  const handleEditVideoPopup = (ball) => {
    console.log("handleEditVideoPopup", ball);
    let newStr = ball.BallUrl.substring(0, ball.BallUrl.lastIndexOf("_"));

    // 🛠️ Format the object for EditBallPopup
    const formattedBallData = {
      Id: ball.Id ?? "-1",
      MatchId: ball.MatchId ?? "",
      DRSTypeId: ball.DRSTypeId ?? (ball.DRSType?.DRSTypeId || ""),
      Description: ball.Description ?? "",
      BallUrl: newStr ?? "",
      DRSVideoUrl: ball.DRSVideoUrl ?? "",
      DeploymentSystemId: ball.DeploymentSystemId ?? "",
    };

    console.log("Formatted Ball Data:", formattedBallData);

    // 🏏 Open the Edit Popup
    setSelectedBall(formattedBallData);
    setShowPopup(true);
  };

  const handleVisibility = () => {
    setPopup(!isVisible);
    setActiveCamTab("cam1");
    setFourCam(false);
    setSixCam(false);
    setSingleCam(true);
    setShapes(shapesForDrawLine);
    setActiveTool(null);
    setShapeVisibility({});
  };

  const handleSingleCamChange = () => {
    setSingleCam(true);
    setFourCam(false);
    setSixCam(false);
    setIsSixCamActive(false);
    setIsFourCamActive(false);
  };

  const handleFourCamChange = () => {
    setSingleCam(false);
    setFourCam(true);
    setSixCam(false);
    setIsSixCamActive(false);
    setIsFourCamActive(true);
  };

  const handleSixCamChange = () => {
    setSingleCam(false);
    setFourCam(false);
    setSixCam(true);
    setIsSixCamActive(true);
    setIsFourCamActive(false);
  };

  const [shapeVisibility, setShapeVisibility] = useState({});

  const [activeTool, setActiveTool] = useState(null);
  const [shapes, setShapes] = useState(shapesForDrawLine);

  const toolData = [
    { id: "impactBall", label: "Impact point", icon: impactIcon },
    { id: "pitchingBall", label: "Pitching point", icon: pitchingIcon },
    { id: "line2", label: "Horizontal grid", icon: horizontalIcon },
    { id: "line1", label: "Vertical grid", icon: verticalIcon },
    { id: "rectangle", label: "Pitch map", icon: pitchMapIcon },
  ];

  // Update shape positions and sizes
  const updateShape = (key, camKey, data, topLevel = false) => {
    setShapes((prev) => ({
      ...prev,
      [key]: topLevel
        ? { ...prev[key], ...data }
        : {
            ...prev[key],
            [camKey]: {
              ...prev[key][camKey],
              ...data,
            },
            color: prev[key].color,
          },
    }));
  };

  const onRectangleResize = (
    e,
    direction,
    ref,
    delta,
    position,
    key,
    camKey
  ) => {
    const { width, height } = ref.getBoundingClientRect();
    const { x, y } = position;
    const shape = shapes[key][camKey];

    let newShape = { ...shape };

    if (direction === "top") {
      const dy = shape.y - y;
      newShape.y = y;
      newShape.height += dy;
    } else if (direction === "bottom") {
      newShape.height = height;
    } else if (direction === "left") {
      const dx = shape.x - x;
      newShape.x = x;
      newShape.width += dx;
    } else if (direction === "right") {
      newShape.width = width;
    }

    updateShape(key, camKey, newShape);
  };
  const columns = [
    { name: "Match Name ", selector: (row) => row.Name, sortable: true },
    {
      name: "Cricket Associtions",
      selector: (row) => getDeploymentSystemName(row.DeploymentSystemId),
      sortable: true,
    },
  ];

  function getDeploymentSystemName(id) {
    const system = cricketAsscotions.find(
      (item) => item.DeploymentSystemId === id
    );
    return system ? system.DeploymentSystemName : null; // returns null if not found
  }

  // Component for expanded row content

  const RowDetails = ({ data }) => {
    const [expandedTypeIds, setExpandedTypeIds] = useState([]);
    // useEffect(() => {
    //   // When data loads, open all DRSTypeIds by default
    //   if (data?.BallsByType && data.BallsByType.length > 0) {
    //     setExpandedTypeIds(data.BallsByType.map((t) => t.DRSTypeId));
    //   }
    // }, [data]);

    const toggleExpand = (id) => {
      if (expandedTypeIds.includes(id)) {
        // Close it
        setExpandedTypeIds(expandedTypeIds.filter((item) => item !== id));
      } else {
        // Open it
        setExpandedTypeIds([...expandedTypeIds, id]);
      }
    };

    return (
      <div className="rowdetails-container">
        {data.BallsByType && data.BallsByType.length > 0 ? (
          data.BallsByType.map((type) => (
            <div key={type.DRSTypeId} className="drstype-card">
              {/* Header */}
              <div
                className="drstype-header"
                onClick={() => toggleExpand(type.DRSTypeId)}
              >
                <span>
                  {type.DRSType?.Title || `DRSTypeId: ${type.DRSTypeId}`}
                </span>
                <span className="toggle-icon">
                  {expandedTypeIds.includes(type.DRSTypeId)
                    ? "▲ Hide Balls"
                    : "▼ Show Balls"}
                </span>
              </div>

              {/* Table */}
              {expandedTypeIds.includes(type.DRSTypeId) && (
                <div className="table-wrapper">
                  <table className="balls-table">
                    <thead>
                      <tr>
                        {/* <th>Ball Id</th> */}
                        <th style={{ width: "70%" }}>Description</th>
                        <th>Play Ball Video</th>
                        {systemRole === UserSystemRole.ADMIN.id && (
                          <th>Edit</th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {type.Balls && type.Balls.length > 0 ? (
                        type.Balls.map((ball, idx) => (
                          <tr
                            key={ball.Id}
                            className={idx % 2 === 0 ? "even" : "odd"}
                          >
                            {/* <td>{ball.Id}</td> */}
                            <td style={{ width: "70%" }}>{ball.Description}</td>
                            <td className="video-cell">
                              {ball.BallUrl ? (
                                <div
                                  onClick={() => handlevideopopup(ball.BallUrl)}
                                >
                                  <img
                                    style={{
                                      height: "30px",
                                      cursor: "pointer",
                                    }}
                                    src={VideoIcon}
                                    alt=""
                                  />
                                </div>
                              ) : (
                                <span className="na-text">N/A</span>
                              )}
                            </td>
                            {systemRole === UserSystemRole.ADMIN.id && (
                              <td className="video-cell">
                                {" "}
                                <div
                                  className="  "
                                  onClick={() => handleEditVideoPopup(ball)}
                                >
                                  <img
                                    style={{
                                      height: "30px",
                                      cursor: "pointer",
                                    }}
                                    src={EditIconNew}
                                    alt=""
                                  />
                                </div>{" "}
                              </td>
                            )}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="3" className="no-data">
                            🚫 No Balls available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          ))
        ) : (
          <div className="no-types">No Appeal Types available</div>
        )}
      </div>
    );
  };

  return (
    <div className="">
      {!isLogin ? (
        <div className="container">
          <LoginCard />
        </div>
      ) : (
        <div className="container">
          {systemRole === UserSystemRole.ADMIN.id && (
            <div className="buttons-container">
              <div
                className="export_pdf_btn"
                onClick={() => setShowAddMatch(true)}
              >
                Add Match
              </div>
              <div
                className="export_pdf_btn"
                onClick={() => setShowAddBall(true)}
              >
                Add Ball
              </div>
            </div>
          )}

          <DataTable
            // title="DRS Video Management"
            columns={columns}
            data={matches}
            theme="solarized"
            customStyles={custombatsmanbowlertableStyles}
            conditionalRowStyles={conditionalRowStyles}
            expandableRows
            expandableRowsComponent={RowDetails} // Show details when row clicked
            highlightOnHover
            fixedHeader // Fix the header
            fixedHeaderScrollHeight="100vh" // Only the body scrolls, adjust height as needed
            responsive
            expandableRowExpanded={(row) => true} 
          />

          {showAddMatch && (
            <AddMatchPopup
              onClose={() => setShowAddMatch(false)}
              loadData={loadintialData}
              cricketAsscotions={cricketAsscotions}
            />
          )}
          {showAddBall && (
            <AddBallPopup
              drsTypes={drsTypes}
              matchData={matches}
              onClose={() => setShowAddBall(false)}
              loadData={loadintialData}
              cricketAsscotions={cricketAsscotions}
            />
          )}

          {showPopup && (
            <EditBallPopup
              drsTypes={drsTypes}
              matchData={matches}
              cricketAsscotions={cricketAsscotions}
              onClose={() => setShowPopup(false)}
              loadData={loadintialData}
              existingBallData={selectedBall}
            />
          )}

          {isVisible && (
            <PopupVideo
              singlecam={singlecam}
              cameraview={cameraview}
              handleSixCamChange={handleSixCamChange}
              handleFourCamChange={handleFourCamChange}
              SixCamImg={SixCamImg}
              FourCamImg={FourCamImg}
              ballurls={ballurls}
              activeCamTab={activeCamTab}
              handleCamTab={handleCamTab}
              toolData={toolData}
              shapeVisibility={shapeVisibility}
              activeTool={activeTool}
              setActiveTool={setActiveTool}
              setShapeVisibility={setShapeVisibility}
              updateShape={updateShape}
              shapes={shapes}
              onRectangleResize={onRectangleResize}
              hexToRGBA={hexToRGBA}
              fourcam={fourcam}
              sixcam={sixcam}
              handleVisibility={handleVisibility}
            />
          )}
        </div>
      )}
    </div>
  );
}
